import * as React from "react";
import { TModuleProps } from "../../../services/playground";
import { TBannerItem } from "../../../services/banner";

import { NavContainer, TitleBox } from "./style";
import { bannerPlaceholder456 } from "utils/playground/banner";
import ImageView from "../../../components/SmartImage";

export interface PCLitbNavProps extends TModuleProps {
  navModules: TBannerItem[];
}

const PCLitbNav: any = (props: PCLitbNavProps) => {
  const { positionId, navModules, stickToTop } = props;
  const onScroll = (link: string) => () => {
    const linkID: string = link.substr(1);
    const dom: HTMLElement | null = document.getElementById(linkID);
    dom?.scrollIntoView({ block: "start" });
    setTimeout(() => {
      window.scrollBy(0, -(stickToTop ? stickToTop : 0));
    }, 0);
  };
  return (
    <section id={positionId}>
      <NavContainer>
        {navModules.map((ele, index) => {
          return (
            <a key={index} onClick={onScroll(ele.link)}>
              <TitleBox
                color={ele.bgColor === ("#ffffff" || "#fff") ? "#666" : "#fff"}
                bgColor={ele.bgColor || "#fff"}
              >
                {ele.text}
              </TitleBox>
              <ImageView
                src={ele.img}
                placeholder={bannerPlaceholder456}
                alt={ele.text}
              />
            </a>
          );
        })}
      </NavContainer>
    </section>
  );
};

export default PCLitbNav;
